import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminClientsComponent from '../components/admin/AdminClients';
import '../styles/admin.css';

export default function AdminClients() {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Gestion des Clients" 
          subtitle="Gérez votre relation client et suivez vos projets"
        />
        <AdminClientsComponent />
      </div>
    </div>
  );
}